"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assignment = void 0;
var Assignment;
(function (Assignment) {
    function from(content, settings) {
        return {
            ...content,
            settings,
            status: settings.status,
            visibilityState: settings.visibility,
            pincode: settings.type === 'realtime' ? settings.pincode : undefined,
        };
    }
    Assignment.from = from;
    function isRealtime(assignment) {
        return assignment.type == 'realtime';
    }
    Assignment.isRealtime = isRealtime;
    function isHomework(assignment) {
        return assignment.type === 'homework';
    }
    Assignment.isHomework = isHomework;
    function isTest(assignment) {
        return assignment.type === 'test';
    }
    Assignment.isTest = isTest;
})(Assignment || (exports.Assignment = Assignment = {}));
//# sourceMappingURL=Assignment.js.map